import React, { useState } from 'react'
import { languages, texts, defaultLanguage, languageNames } from './Translations'
import { Visualization2D, MkSoup, MkClient } from './Visualization2D'
import { VisualizationTable, get_shallow_state } from './VisualizationTable'

import ChefSad from './images/chef_t_sad.svg'
import ChefHappy from './images/chef_t_happy.svg'

import Rabbit2 from './images/rabbit_2.svg'
import Rabbit2Sad from './images/rabbit_sad_2.svg'
import Rabbit2_simple from './images/rabbit_simple_2.svg'
import Rabbit2Sad_simple from './images/rabbit_sad_simple_2.svg'

let delta = 0.23;
let delta_visual = 0.2;
let object_scale = 0.08;
let near_clients_rotate = false;

export function Page() {
    // Ici, on déclare les différents widgets
    // C'est un dictionnaire qui fait correspondre un nom (ie 'page 0') à un ensemble de clients et de soupes
    let widgets = {
        'page 3': {
            delta, delta_visual, object_scale, near_clients_rotate,
            compositeSoups: false,
            objects: [
                useState(() => MkSoup({ displayArrows: [true, true, true] }))
            ]
        },
        'page 4': {
            delta, delta_visual, object_scale, near_clients_rotate,
            compositeSoups: false,
            objects: [
                useState(() => MkSoup({})),
                useState(() => MkClient('bear', {position: [0.7, 0.3, 0], movable: false})),
            ]
        },
        'page 5': {
            delta, delta_visual, object_scale, near_clients_rotate,
            compositeSoups: false,
            objects: [
                useState(() => MkSoup({})),
                useState(() => MkClient('rabbit', {position: [0.05, 0.3, 0.65], movable: false})),
                useState(() => MkClient('bear', {position: [0.7, 0.3, 0], movable: false})),
                useState(() => MkClient('fox', {position: [0.18, 0.07, 0.75], movable: false})),
                useState(() => MkClient('rabbit', {position: [0.22, 0.46, 0.32], movable: false}, Rabbit2, Rabbit2Sad)),
            ]
        },
        'page 7': {
            delta, delta_visual, object_scale, near_clients_rotate,
            compositeSoups: false,
            objects: [
                useState(() => MkSoup({})),
                useState(() => MkSoup({})),
                useState(() => MkClient('rabbit', {position: [0.05, 0.3, 0.65], movable: false})),
                useState(() => MkClient('bear', {position: [0.7, 0.3, 0], movable: false})),
                useState(() => MkClient('fox', {position: [0.18, 0.07, 0.75], movable: false})),
                useState(() => MkClient('rabbit', {position: [0.22, 0.46, 0.32], movable: false}, Rabbit2, Rabbit2Sad)),
            ]
        },
        'page 9': {
            delta, delta_visual, object_scale, near_clients_rotate,
            compositeSoups: true,
            objects: [
                useState(() => MkSoup({})),
                useState(() => MkSoup({})),
                useState(() => MkClient('bear', {position: [0.7, 0.3, 0], movable: false})),
            ]
        },
        'page 10': {
            delta, delta_visual, object_scale, near_clients_rotate,
            compositeSoups: true,
            objects: [
                useState(() => MkSoup({})),
                useState(() => MkSoup({})),
                useState(() => MkClient('rabbit', { position: [0.05, 0.3, 0.65], movable: false})),
                useState(() => MkClient('bear', {position: [0.7, 0.3, 0], movable: false})),
                useState(() => MkClient('fox', {position: [0.18, 0.07, 0.75], movable: false})),
                useState(() => MkClient('rabbit', {position: [0.22, 0.46, 0.32], movable: false}, Rabbit2, Rabbit2Sad)),
            ]
        },
        'test-composite': {
            delta, delta_visual, object_scale, near_clients_rotate,
            compositeSoups: true,
            objects: [
                useState(() => MkSoup({})),
                useState(() => MkSoup({})),
                useState(() => MkClient('rabbit', {})),
                useState(() => MkClient('bear', {})),
                useState(() => MkClient('fox', {})),
                useState(() => MkClient('rabbit', {}, Rabbit2, Rabbit2Sad)),
            ]
        }
    };

    //let update_client_vec = function(widget: string, client_index: number): (vec: Vector) => void {
    //    return vec => widgets[widget].setClients(
    //        widgets[widget].clients.map((client, i) =>
    //            i == client_index
    //                ? Object.assign(Object.assign({}, client), { vec })
    //                : client)
    //    );
    //}
    //
    //let shallow_client_state_of = (widget: string, i: number) => get_shallow_state(widgets[widget].objects[i], update_client_vec(widget, i));
    //
    //    let cache: { [key: string]: { [key: number]: [Object, (i: number, comp: number) => void] } } = {};
    //    let input_client_vec_comp = (widget: string, client_index: number, percentage = false) => {
    //        cache[widget] = cache[widget] || [];
    //        cache[widget][client_index] = cache[widget][client_index] || shallow_client_state_of(widget, client_index);
    //        let [fake, setFake] = cache[widget][client_index]; //shallow_client_state_of(widget, client_index);
    //        let round: (n: number) => number = percentage ? (n => Math.round(n)) : (n => Math.round(n * 100) / 100);
    //        return (component_index: number) => (
    //            <input
    //                className={"input_client_vec_comp"}
    //                type={"number"}
    //                step={percentage ? 1 : 0.05}
    //                value={round(fake[component_index] * (percentage ? 100 : 1))}
    //                onChange={e => setFake(component_index, +e.target.value / (percentage ? 100 : 1))}
    //            />
    //        );
    //    };

    let [lang, setLang] = useState(() => defaultLanguage);
    let t = (s: keyof typeof texts): string => {
        if (!(s in texts))
            throw "The key " + s + " was not found in translations.";
        return texts[s][lang];
    };

    return (
        <div>
            <header>
                <h1>{t('title')}</h1>
                <p>{t('subtitle')}</p>
                <div className='header_credits_logos'>
                    <ul className='credits'>
                        <li><a href="https://jeremy-e-cohen.jimdofree.com" target="_blank">{t('credits_J')}</a></li>
                        <li><a href='https://anaisrallo.com' target="_blank">{t('credits_A')}</a></li>
                        <li><a href="https://lucas.franceschino.fr" target="_blank">{t('credits_LF')}</a></li>
                        <li><a href="https://luciegoujon.fr" target="_blank">{t('credits_LG')}</a></li>
                    </ul>
                    <div className='logos'>
                        <img id="logo_cnrs" src="./images/pngs/cnrs_2022.png" alt="CNRS" />
                        <img id="logo_anr" src="./images/ANR-logo-2021-sigle.jpg" alt="ANR" />
                    </div>
                </div>
                <div className="languages">
                    {languages.filter(l => l != lang).map((l, i) => <button key={i} onClick={() => setLang(l)}>{languageNames[l]}</button>)}
                </div>
            </header>
            <section id="main">
                <h2>{t('first_1')}</h2>
                <div className="first">
                    <div className="first__soup-shop">
                        <img src="./images/soup_shop.svg" alt="" />
                    </div>
                    <div className="first__text">
                        <p>{t('first_2')}</p>
                        <p className="strong">{t('first_3')}</p>
                        <p>{t('first_4')}</p>
                    </div>
                </div>
                <div className="second">
                    <p>{t('second_1')}</p>
                    <div className="second__img">
                        <div id="dancing-leaks"><img src="./images/dancing_leaks.svg" alt="" /></div>
                        <p id="leaks">{t('second_2')}</p>
                        <div id="sleepy-onion"><img src="./images/sleepy_onion.svg" alt="" /></div>
                        <div id="onion-team"><img src="./images/onion_team.svg" alt="" /></div>
                        <p id="onions">{t('second_3')}</p>
                        <div id="carrots"><img src="./images/3_carrots.svg" alt="" /></div>
                        <div id="carrot-smiling"> <img src="./images/smiling_carrot.svg" alt="" /></div>
                        <p id="carrots-text">{t('second_4')}</p>
                    </div>
                </div>
                <h2>{t('third_1')}</h2>
                <div className="third">
                    <div className="third__top">
                        <p>{t('third_2')}</p>
                        <div className="third__top--text">{t('third_3')}</div>
                    </div>
                    <div className="third__bottom">
                        <Visualization2D {...widgets['page 3']} />
                        <img className="third__bottom--img" alt="" src={
                            (([onion, carrot, leak]) =>
                                onion <= 0.1 && carrot >= 0.6 ? ChefSad : ChefHappy
                            )(widgets['page 3'].objects[0][0].vec)
                        } />
                    </div>
                </div>
                <div className="fourth">
                    <div className="fourth__topleft">
                        <p className="strong">{t('fourth_1')}</p>
                        <p>{t('fourth_2')}</p>
                        <p>{t('fourth_3')}</p>
                        <p>{t('fourth_4')}</p>
                    </div>
                    <div className="fourth__topright">
                        <div className="fourth__topright--img"><img src="./images/chef_soup_shop.svg" alt="" /></div>
                    </div>
                    <div className="fourth__middleleft"><img src="./images/cooking_pot.svg" alt="" /></div>
                    <div className="fourth__middleright">
                        <p>{t('fourth_5')}</p>
                        <p>{t('fourth_6')}</p>
                    </div>

                    <div className="fourth__bottomleft">
                        <div className="fourth__bottomleft--text">{t('fourth_7')}</div>
                        <div className="fourth__bottomleft--graph">
                            <Visualization2D {...widgets['page 4']} />
                        </div>
                    </div>
                    <div className="fourth__bottomright">
                        <VisualizationTable {...widgets['page 4']} />
                    </div>
                </div>
                <h2>{t('fifth_1')}</h2>
                <div className="fifth">
                    <div className="fifth__top">
                        <p>{t('fifth_2')}</p>
                        <p>{t('fifth_3')}</p>
                        <p>{t('fifth_4')}</p>
                    </div>
                    <div className="fifth__middle">
                        <div className="fifth__middle--graph">
                            <Visualization2D {...widgets['page 5']} />
                        </div>
                        <div className="fifth__middle--table">
                            <VisualizationTable {...widgets['page 5']} />
                        </div>
                    </div>
                    <div className="fifth__bottom">
                        <p>{t('fifth_5')}</p>
                        <p>{t('fifth_6')}</p>
                        <p>{t('fifth_7')}</p>
                    </div>
                </div>
                <h2>{t('sixth_1')}</h2>
                <div className="sixth">
                    <div className="sixth__grid">
                        <div className="sixth__left">
                            <p>{t('sixth_2')}</p>
                            <p>{t('sixth_3')}</p>
                        </div>
                        <div className="sixth__center">
                            <img src="./images/chef_cooking.svg" alt="" />
                        </div>
                        <div className="sixth__right">
                            <p>{t('sixth_4')}</p>
                            <p>{t('sixth_5')}</p>
                            <p>{t('sixth_6')}</p>
                        </div>
                    </div>
                </div>
                <div className="seventh">
                    <div className="seventh__middle">
                        <div className="seventh__middle--graph">
                            <Visualization2D {...widgets['page 7']} />
                        </div>
                        <div className="seventh__middle--table">
                            <VisualizationTable {...widgets['page 7']} />
                        </div>
                    </div>
                    <div className="seventh__text">
                        <p id="footnote_1_source">{t('seventh_1')}<sup><a href="#footnote_1">1</a></sup></p>
                        <p>{t('seventh_2')}</p>
                        <p>{t('seventh_3')}</p>
                    </div>
                </div>
                <h2 className="eighth__title">{t('eighth_1')}</h2>
                <div className="eighth">
                    <div className="eighth__grid">
                        <div className="eighth__text">
                            <p>{t('eighth_2')}</p>
                            <p>{t('eighth_3')}</p>
                            <p>{t('eighth_4')}</p>
                        </div>
                        <div className="eighth__image">
                            <img src="./images/chef_and_gaston_speaking.svg" alt="" />
                        </div>
                    </div>
                </div>
                <div className="ninth">
                    <div className="ninth__top">
                        <div className="ninth__image_left">
                            <img src="./images/soup_dab_2.svg" alt="" />
                        </div>
                        <div className="ninth__text_top">
                            <p>{t('ninth_1')}</p>
                            <p>{t('ninth_2')}</p>
                            <p>{t('ninth_3')}</p>
                        </div>
                        <div className="ninth__image_right">
                            <img src="./images/soup_dab.svg" alt="" />
                        </div>
                    </div>
                    <div className="ninth__text_bottom">
                        <p>{t('ninth_4')}</p>
                        <p>{t('ninth_5')}</p>
                    </div>
                    <div className="ninth__bottom">
                        <div className="ninth__bottom--graph">
                            <Visualization2D {...widgets['page 9']} />
                        </div>
                        <div className="ninth__bottom--table">
                            <VisualizationTable {...widgets['page 9']} />
                        </div>
                    </div>
                </div>
                <div className="tenth">
                    <div className="tenth__top">
                        <div className="tenth__top--text">
                            <p>{t('tenth_1')}</p>
                            <p>{t('tenth_2')}</p>
                            <p>{t('tenth_3')}</p>
                            <p id="footnote_2_source">{t('tenth_4')}<sup><a href="#footnote_2">2</a></sup></p>
                        </div>
                        <div className="tenth__top--image">
                            <img src="./images/happy_chef.svg" alt="" />
                        </div>
                    </div>
                    <div className="tenth__bottom">
                        <div className="tenth__bottom--graph">
                            <Visualization2D {...widgets['page 10']} />
                        </div>
                        <div className="tenth__bottom--table">
                            <VisualizationTable {...widgets['page 10']} />
                        </div>
                    </div>
                </div>
                <h2>{t('eleventh_1')}</h2>
                <div className="eleventh">
                    <p>{t('eleventh_2')}</p>
                    <p>{t('eleventh_3')}</p>
                    <p>{t('eleventh_4')}</p>
                    <p>{t('eleventh_5')}</p>
                </div>
                <div className="tenth__bottom">
                    <div className="tenth__bottom--graph">
                        <Visualization2D {...widgets['test-composite']} />
                    </div>
                    <div className="tenth__bottom--table">
                        <VisualizationTable {...widgets['test-composite']} />
                    </div>
                </div>
            </section>
            <footer>
                <ul>
                    <li id="footnote_1">
                        <a href="#footnote_1_source">1. </a>
                        {t('footer_1_1')}
                        <a href={t('footer_1_2_url')}>{t('footer_1_2')}</a>
                        {t('footer_1_3')}
                        <a href={t('footer_1_4_url')}>{t('footer_1_4')}</a>
                        {t('footer_1_5')}
                    </li>
                    <li id="footnote_2">
                    <a href="#footnote_2_source">2. </a>
                        {t('footer_2_1')}
                        <a href={t('footer_2_2_url')}>{t('footer_2_2')}</a>
                        {t('footer_2_3')}
                        <a href={t('footer_2_4_url')}>{t('footer_2_4')}</a>
                        {t('footer_2_5')}
                        <a href={t('footer_2_6_url')}>{t('footer_2_6')}</a>
                        {t('footer_2_7')}
                    </li>
                </ul>
                <p>{t('footer_credits')}</p>
            </footer>
        </div>
    );
}

